export default (...objects: Object[]) =>
  Object.entries(objects.reduce((prev, obj) => ({ ...prev, ...obj }), {})).reduce(
    (prev, [key, value]) => ({ ...prev, [key]: { key, value } }),
    {}
  );
